// extracted by mini-css-extract-plugin
export var askAiIcon = "_pi-9";
export var container = "_pi-0";
export var groupSeparator = "_pi-a";
export var highlight = "_pi-4";
export var resultIcon = "_pi-5";
export var resultItem = "_pi-7";
export var resultSubtitle = "_pi-3";
export var resultTitle = "_pi-2";
export var resultsList = "_pi-1";
export var searchGroup = "_pi-6";
export var selected = "_pi-8";